import {showToast} from 'vant';
import {useHHttp} from "@/hooks/useHHttp.js";
import {useUserStore} from "@/stores/useUser.js";
import {hr} from "@/components/utils/HRouter.js";
import {emitter, hcf, log} from "@/components/utils/HComFunctions.js";

// 进游戏 in-flight 锁(模块级, 跨所有游戏入口组件共享): 一次 /game/enter 未结束前禁止再次发起,
// 防止慢网下连点发出多个 /game/enter 而叠出多个游戏 iframe。
let gameEntering = false;

export function useClickModal() {
    const user = useUserStore();
    const http = useHHttp();


    function inGame(arg) {
        if (!user.isLogin) {
            hr.go("login");
            return;
        }
        if (gameEntering) {
            return;
        }
        gameEntering = true;
        http.request(
            "/game/enter",
            (data) => {
                emitter.emit("EVENT_INTO_GAME", {"game_url": data["GameUri"], "game_id": arg["paras"],leaveArgument: arg["leaveArgument"]})
            },
            {
                errCallBack: (resp) => {
                    if (resp["c"] === 10901001) {
                        http.request("/game/entry-alert", (data) => {
                                emitter.emit("EVENT_INTO_GAME_ALERT", {
                                    gameName: arg["name"],
                                    gameId: arg["paras"],
                                    leaveArgument: arg["leaveArgument"],
                                    initData: data,
                                });
                            },
                            {
                                isShowLoading: false,
                                params: {
                                    "user_id": user.userId,
                                },
                            }
                        ).then(r => {
                        });
                    } else {
                        showToast(resp["m"]);
                    }
                },
                params: {
                    "UserId": user.userId,
                    "GameId": arg["paras"],
                    "Balance": 0,
                    "Confirm": 0,
                },

                // 首次发协议即刻弹出全屏 loading 遮罩阻断操作(0 延迟, 关掉原 50ms 连点窗口)
                loadingDelayMillTime: 0,
                loadingText: "正在进入游戏"
            }
        ).finally(() => {
            gameEntering = false;
        });
    }

    function onClick(clickItem) {
        const type = clickItem["ClickType"];
        const arg = clickItem["ClickParam"];
        if ((clickItem["ClickLogin"] ?? false) && !user.isLogin) {
            hr.go('login');
            return;
        }
        switch (type) {
            case 1: // 1=游戏 arg=gameid
                inGame(arg);
                break;
            case 2: // 2=大厅
                hr.go("lobby", arg);
                break;
            case 3:
                hr.go("wb", {"title": arg["Title"], "url": arg["Url"]});
                break;
            case 4:
                if (arg != null) {
                    hcf.launchUrl(arg);
                }
                break;
            case 5:
                emitter.emit("HOME_BOTTOM_TAB_CHANGE", arg);
                break;
            case 6: //跳转页面
                if (arg != null) {
                    try {
                        hr.go(arg);
                    } catch (e) {
                        showToast("跳转页面错误:" + arg);
                    }
                }
                break;
            default:
                log("跳转异常, type:" + type);
                break;
        }
    };

    return {
        onClick,
    };
}
